export const name = "ST_INTERSECTION";
export const summary = `Gets the point set intersection of two \`GEOGRAPHY\` values.`;
export const reference = `
## ST_INTERSECTION

Gets the point set intersection of two \`GEOGRAPHY\` values.

\`\`\`
ST_INTERSECTION(geography_1, geography_2)
\`\`\`

### Description

Returns a \`GEOGRAPHY\` that represents the point set intersection of the two input \`GEOGRAPHY\`s. Thus, every point in the intersection appears in both \`geography_1\` and \`geography_2\`.

If the two input \`GEOGRAPHY\`s are disjoint, that is, there are no points that appear in both input \`geometry_1\` and \`geometry_2\`, then an empty \`GEOGRAPHY\` is returned.

See ST_INTERSECTS, ST_DISJOINT for related predicate functions.


### Return type

\`GEOGRAPHY\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
